function Verified({ dimensions, col = '#000', tickCol = '#fff' }) {
  const baseXml = `
    <svg width="${dimensions || 40}" height="${dimensions || 40}" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="16" fill="${tickCol}"/>
      <path d="M40 19.5L35.5636 14.3186L36.1818 7.46571L29.6182 5.94286L26.1818 0L20 2.71143L13.8182 0L10.3818 5.92429L3.81818 7.42857L4.43636 14.3L0 19.5L4.43636 24.6814L3.81818 31.5529L10.3818 33.0757L13.8182 39L20 36.27L26.1818 38.9814L29.6182 33.0571L36.1818 31.5343L35.5636 24.6814L40 19.5ZM16.5273 28.2657L9.61818 21.19L12.3091 18.4414L16.5273 22.7686L27.1636 11.8671L29.8545 14.6157L16.5273 28.2657Z" fill="${col}"/>
    </svg>
  `;

  return baseXml;
}

export default Verified;
